export function positiveNumberValidator($el) {
  if (!$el.val()) {
    return true;
  }
  const value = $el[0].valueAsNumber;
  return !isNaN(value) && value > 0;
}
Foundation.Abide.defaults.validators["positive_number"] = positiveNumberValidator;
